import { getRouteApi } from '@tanstack/react-router';

import { MediaImagesDashboard as EstateMediaImagesDashboard } from '@/features/estate-media/components/media-images-dashboard';
import { MediaImagesDashboard as ProjectMediaImagesDashboard } from '@/features/project-media/components/media-images-dashboard';

const route = getRouteApi('/_authenticated/_sidebar-layout');

export const MediaImages = () => {
  const { estateId } = route.useParams();

  return estateId ? <EstateMediaImagesDashboard /> : <ProjectMediaImagesDashboard />;
};
